import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzSelectModule } from '@blk/daisy/combinations/dropdown';
import { SharedModule } from '@ddt-web/common';

import { HomePageLeftNavComponent } from './home-page-left-nav.component';

@NgModule({
	declarations: [HomePageLeftNavComponent],
	imports: [CommonModule, CwpNgFrameworkModule, DzSelectModule, SharedModule],
	exports: [HomePageLeftNavComponent]
})
export class HomePageLeftNavModule { }
